import React from 'react';
import axios from 'axios';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    let email = null;
    let churchId = null;
    try {
      const { secureStorage } = require('../lib/secureStorage');
      const saved = secureStorage.getUser();
      email = saved?.email || null;
      churchId = saved?.church_id || null;
    } catch { /* ignore */ }

    axios.post(`${BACKEND}/api/client-errors`, {
      message: String(error?.message || error).slice(0, 2000),
      stack: String(error?.stack || '').slice(0, 8000),
      component_stack: String(info?.componentStack || '').slice(0, 8000),
      path: window.location.pathname + window.location.search,
      user_email: email,
      church_id: churchId,
    }).catch(() => {});
  }

  render() {
    if (!this.state.error) return this.props.children;

    const detail = `${this.state.error?.message || this.state.error}\n${this.state.info?.componentStack || ''}`;
    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-background" data-testid="error-boundary">
        <div className="max-w-lg w-full rounded-xl border bg-card p-6 text-center">
          <h1 className="text-lg font-semibold text-foreground">Algo falló en esta pantalla</h1>
          <p className="text-sm text-muted-foreground mt-2">
            Ya avisamos al equipo técnico con el detalle del error. Puedes volver al inicio
            y seguir usando el resto de la Suite.
          </p>
          <div className="flex flex-col sm:flex-row gap-2 justify-center mt-5">
            <button
              onClick={() => { window.location.href = '/'; }}
              className="px-4 py-2 rounded-lg bg-[#056A84] text-white text-sm font-medium hover:bg-[#045A70]"
              data-testid="error-boundary-home"
            >
              Volver al inicio
            </button>
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 rounded-lg border text-sm font-medium hover:bg-accent"
              data-testid="error-boundary-reload"
            >
              Reintentar
            </button>
            <button
              onClick={() => navigator.clipboard.writeText(detail)}
              className="px-4 py-2 rounded-lg border text-sm font-medium hover:bg-accent"
              data-testid="error-boundary-copy"
            >
              Copiar detalle
            </button>
          </div>
          <pre className="mt-5 text-[10px] text-left text-muted-foreground whitespace-pre-wrap max-h-40 overflow-y-auto border-t pt-3">
            {detail.slice(0, 600)}
          </pre>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
